import React, { Fragment, useContext, useEffect, useState } from 'react';
import { ActionButton, BaseButton, Button, Checkbox, DefaultButton, Dialog, DialogFooter, DialogType, DocumentCard, DocumentCardActions, DocumentCardActivity, DocumentCardLocation, DocumentCardPreview, DocumentCardTitle, Dropdown, IDropdownOption, Icon, PersonaInitialsColor, PrimaryButton, Text, TextField, Toggle, TooltipHost } from "office-ui-fabric-react";
import { ulid } from 'ulid';
import moment from 'moment-timezone';



import { WsAppContext } from "../../AppContext";

import { Redirect, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";
import { Loading } from "../../Shared";
import { WsConfigTenant, WsTenantStatus } from "./ConfigTenant";



import { apiGet, apiPost } from "../../../helpers-sales";
import { WsConfigNormalization } from "./ConfigNormalization";

import { WsDeliverJobInterface, WsDeliverTenantInterface } from "../../../../../core/src/interfaces";

import { getTenantStatus, getWorkloads } from "../data/deliver-data";
import { WsDeliverTenantStatus } from "../../../enums";

import { WsResourcePage } from "./ResourcePage";

import { WsDeliverPortalContext } from "../DeliverPortalContext";
import { WsJobsPage } from "./JobsPage";

import { WsDeliverTenantAction, WsTenantActionButton } from "./TenantActionButton";




import './ConfigPage.scss';
import { wait } from "../../../helpers";












const getActionDialogTitle = (name: string) => {
  if (name === 'compare') {
    return 'Compare';
  } else if (name === 'migrate') {
    return 'Migrate';
  } else if (name === 'clone') {
    return 'Clone';
  } else if (name === 'blueprint') {
    return 'Create Blueprint';
  } else if (name === 'backup') {
    return 'Backup';
  } else if (name === 'restore') {
    return 'Restore';
  } else if (name === 'deploy') {
    return 'Deploy';
  } else {
    return 'Action';
  }
};

type WsTenantActionDialogProps = {
  tenants: WsDeliverTenantInterface[];
  action: WsDeliverTenantAction;
  hideDialog: () => void;
};

const WsTenantActionDialog = (props: WsTenantActionDialogProps) => {

  const history = useHistory();

  const [ compareTenantId, setCompareTenantId ] = useState<string>('');

  const [ selectedSnapshotId, setSelectedSnapshotId ] = useState<string>('');

  const [ selectedKeys, setSelectedKeys ] = React.useState<string[]>([]);

  const [ jobList, setJobList ] = useState<WsDeliverJobInterface[] | undefined>(undefined);



  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.hideDialog();
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.hideDialog();
  };

  const onClickUpdate = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.hideDialog();

    if (props.action.name === 'compare') {
      history.push(`/deliver/config/m365-tenants/${props.action.tenantId}/compare/${compareTenantId}`);
    }

    if (props.action.name === 'restore') {
      history.push(`/deliver/config/m365-tenants/${props.action.tenantId}/restore/${selectedSnapshotId}/${selectedKeys.join(',')}`);
    }

    if (props.action.name === 'clone') {
      history.push(`/deliver/config/m365-tenants/${compareTenantId}/clone/${props.action.tenantId}/${selectedKeys.join(',')}`);
    }
  };



  const loadJobData = async (clearState: boolean) => {

    if (clearState) {
      setJobList(undefined);
    }

    const result = await apiGet(`/deliver/jobs/${props.action.tenantId}?include=all`);

    if (result && Array.isArray(result.jobs)) {
      const resultData = result.jobs as WsDeliverJobInterface[];
      const filterData = resultData.filter((item) => item.data.action === 'BACKUP' && item.data.status === 'COMPLETE');
      // console.log(filterData);
      setJobList(filterData);
    }
  };

  useEffect(() => {
    loadJobData(false);
  }, []);



  const getDialogContent = () => {
    const content: any = [];

    // first field

    if (props.action.name === 'restore' || props.action.name === 'clone') {
      
      if (props.action.name === 'restore') {

        // select snapshot

        content.push(
          <div key={`ws-backup-tenant`} className="columns">
            <div className="column is-4" style={{ paddingTop: '18px' }}>
              Select Backup:
            </div>
            <div className="column">
              {
                jobList
                ?
                <Dropdown
                  // label={props.label}
                  options={
                    jobList.length > 0
                    ?
                    jobList.map((item) => {
                      return { key: item.data.jobId, text: `Backup ${moment(item.modifiedAt).format('HH:mm')}, ${moment(item.modifiedAt).format('DD/MM/YYYY')}` };
                    })
                    :
                    [
                      { key: '0', text: 'Backup 02:00, 02/09/2024' }
                    ]}
                  onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                    if (option) {
                      setSelectedSnapshotId(`${option.key}`);
                    }
                  }}
                  selectedKey={selectedSnapshotId}
                  placeholder="Select Backup"
                />
                :
                <div className="Toastify__toast-icon"><div className="Toastify__spinner"></div></div>
              }
            </div>
          </div>
        );



      } else if (props.action.name === 'clone') {



        // target tenant

        content.push(
          <Fragment key={`ws-more-fields`}>
            <div className="columns">
              <div className="column is-4" style={{ paddingTop: '18px' }}>
                Target Tenant:
              </div>
              <div className="column">
                <Dropdown
                  // label={props.label}
                  options={
                    props.tenants
                    .filter((t) => t.azureTenantId !== props.action.tenantId)
                    .sort((a, b) => { // TODO: improve sorting
                      if (a.id && b.id) {
                        if (a.id < b.id) return -1;
                        if (a.id > b.id) return 1;
                        return 0;
                      } else {
                        return 0;
                      }
                    })
                    .map((t) => {
                      return {
                        key:  t.azureTenantId,
                        text: t.name
                      };
                    })
                  }
                  onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                    if (option) {
                      setCompareTenantId(`${option.key}`);
                    }
                  }}
                  selectedKey={compareTenantId}
                  placeholder="Select Tenant"
                />
              </div>
            </div>
          </Fragment>
        );

      }



      // workloads

      content.push(
        <div key={`ws-backup-workload`} className="columns">
          <div className="column is-4" style={{ paddingTop: '18px' }}>
            Select Workloads:
          </div>
          <div className="column">
            <Dropdown
              style={{ maxWidth: '260px' }}
              multiSelect
              // label={props.label}
              options={
                [
                  { key: 'all', text: 'All Workloads' },
                  ...getWorkloads().map((workloadItem, workloadIndex: number) => {
                    return { key: workloadItem.id, text: workloadItem.name, disabled: !workloadItem.enabled };
                  })
                ]
              }
              onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                if (option) {
                  console.log(option);
                  if (option.key === 'all') {
                    if (option.selected) {
                      setSelectedKeys([ 'all', ...getWorkloads().filter((wli) => wli.enabled).map((wli) => wli.id) ]);
                    } else {
                      setSelectedKeys([]);
                    }
                  } else {
                    setSelectedKeys(option.selected ? [...selectedKeys, option.key as string] : selectedKeys.filter(key => key !== option.key));
                  }
                }
              }}
              selectedKeys={selectedKeys}
              placeholder="Select Workloads"
            />
          </div>
        </div>
      );



      // options

      content.push(
        <div key={`ws-backup-include-user-data`} className="columns">
          <div className="column is-4" style={{ paddingTop: '12px' }}>
            Include User Data:
          </div>
          <div className="column">
            <Checkbox
              // checked={this.props.selectedApplication && this.props.selectedApplication.id === a.id}
              // onChange={(e) => this.select(e, a)}
              // style={{ marginTop: '20x' }}
              // styles={{ root: { marginTop: '20x' }}}
            />
          </div>
        </div>
      );

      content.push(
        <div key={`ws-backup-include-sensitive-data`} className="columns">
          <div className="column is-4" style={{ paddingTop: '12px' }}>
            Include Sensitive Data:
          </div>
          <div className="column">
            <Checkbox
              // checked={this.props.selectedApplication && this.props.selectedApplication.id === a.id}
              // onChange={(e) => this.select(e, a)}
              // style={{ marginTop: '20x' }}
              // styles={{ root: { marginTop: '20x' }}}
            />
          </div>
        </div>
      );

    } else {

      content.push(
        <div key={`ws-source-tenant`} className="columns">
          <div className="column is-4">
            Source Tenant:
          </div>
          <div className="column">
            {props.tenants.find((t) => t.azureTenantId === props.action.tenantId)?.name}
          </div>
        </div>
      );

    }

    // second field

    if (props.action.name === 'blueprint') {

      // blueprint

      content.push(
        <div key={`ws-second-field`} className="columns">
          <div className="column is-4" style={{ paddingTop: '18px' }}>
            Blueprint Name:
          </div>
          <div className="column">
            <TextField
              // value=""  
            />
          </div>
        </div>
      );

    } else {

      if (props.action.name === 'compare') {

        content.push(
          <Fragment key={`ws-more-fields`}>
            <div className="columns">
              <div className="column is-4" style={{ paddingTop: '18px' }}>
                Target Tenant:
              </div>
              <div className="column">
                <Dropdown
                  // label={props.label}
                  options={
                    props.tenants
                    .filter((t) => t.azureTenantId !== props.action.tenantId)
                    .sort((a, b) => { // TODO: improve sorting
                      if (a.id && b.id) {
                        if (a.id < b.id) return -1;
                        if (a.id > b.id) return 1;
                        return 0;
                      } else {
                        return 0;
                      }
                    })
                    .map((t) => {
                      return {
                        key:  t.azureTenantId,
                        text: t.name
                      };
                    })
                  }
                  onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                    if (option) {
                      setCompareTenantId(`${option.key}`);
                    }
                  }}
                  selectedKey={compareTenantId}
                  placeholder="Select Tenant"
                />
              </div>
            </div>
          </Fragment>
        );
      }
    }

    return (
      <>
        {content}
      </>
    );
  };







  return (
    <Dialog
      className="ws-dialog-select ws-deliver-new-tenant-dialog"
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.normal,
        title: `${getActionDialogTitle(props.action.name)} Tenant`
      }}
      modalProps={{
        isBlocking: false,
        styles: {
          // main: { width: 300 }
        }
      }}
    >
      <Fragment>
        <div className="ws-deliver-new-tenant-form">
          {getDialogContent()}
        </div>
      </Fragment>
      <DialogFooter>
        <DefaultButton onClick={onClickCancel} text="Cancel" />
        <PrimaryButton onClick={onClickUpdate} text="OK" disabled={
            !(
              (
                props.action.name === 'restore' && selectedSnapshotId && selectedKeys.length > 0
              )
              ||
              compareTenantId
            )
          }
        />
      </DialogFooter>
    </Dialog>
  );
};





export {
  WsTenantActionDialog
};
